import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import css from './index.module.scss';

const M: React.FC = () => {
    const { t } = useLang('stream.overview');

    return (
        <div className={`${css.section} stream-nl-M GtmModuleData-section`} id="stream-nl-M" data-section-id={'stream-nl-M'}>
            <div className="box">
                <h3 className="title">{t('M_title')}</h3>
                <div className="text">
                    {t.rich('M_text', {
                        a: (tx: string) => <EcoLink href={'https://nl.ecoflow.com/pages/warranty-policy'}>{tx}</EcoLink>,
                        li: (tx: string) => <p className="li">{tx}</p>,
                    })}
                </div>
            </div>
        </div>
    );
};

export default M;
